<p-drawer
  [visible]="display"
  position="right"
  (onHide)="onHide()"
  appendTo="body"
  class="sidebarWidth"
  header="Add note for {{ quoteId }}">
  <div class="mb-2 left-sidebar">
    <form [formGroup]="saleOrderNoteForm">
      <div class="form-group has-float-label mb-2">
        <label class="form-label"
          >Type <span class="madatory-field">*</span></label
        >
        <p-select
          [(ngModel)]="defaultTypeSelection"
          (change)="onPurchaseOrderSelection(defaultTypeSelection)"
          formControlName="type"
          [options]="typeList"
          optionValue="name"
          optionLabel="name"
          [filter]="true"
          [showClear]="true">
        </p-select>
      </div>
      <div class="col-12 mb-2">
        <div class="has-float-label">
          <label class="form-label"
            >Description<span class="madatory-field">*</span></label
          >
          <input
            pInputText
            jniAutoCompleteBlocker
            name="Description"
            type="text"
            class="form-control"
            maxlength="120"
            formControlName="description" />
        </div>
      </div>
      <div class="col-12 mb-2">
        <div class="has-float-label">
          <label class="form-label">Notes</label>
          <textarea
            pInputText
            jniAutoCompleteBlocker
            name="Notes"
            type="text"
            class="form-control"
            formControlName="note"></textarea>
        </div>
      </div>
    </form>

    <div class="mt-3">
      <!-- <button
        class="btn btn-primary me-3 post"
        type="submit"
        [disabled]="!saleOrderNoteForm.valid"
        (click)="onQuoteNotesSave()">
        save
      </button> -->

      <p-button
        label="save"
        [disabled]="!saleOrderNoteForm.valid"
        (click)="onQuoteNotesSave()" />
    </div>
  </div>
</p-drawer>
